import { Transition } from '@oneToOne/shared/twind'
import { css } from 'twind/css'

export const requestVisitorInformationDescription = css({
  color: 'var(--blk2)',
})

export const requestVisitorInformationFormLabel = css({
  color: 'var(--blk2)',
})

export const requestVisitorInformationInput = css({
  border: '1px solid var(--gray-4)',
  borderRadius: 'var(--border-radius-sm)',
  color: 'var(--gray-9)',
})

export const requestVisitorInformationPrivacyInfo = css({
  color: 'var(--gray-8)',
  fontSize: 'var(--font-size-xxs)',
  '& a': {
    textDecoration: 'underline',
  },
})

export const okButton = css({
  ...Transition,
  background: 'var(--primary)',
  borderRadius: 'var(--spacing-4)',
  height: 'var(--spacing-32)',
  fontWeight: 'var(--font-medium)',
  gap: 'var(--spacing-8)',
  '&:disabled': {
    backgroundColor: 'var(--blue-2)',
    filter: 'none',
  },
})
